export function nameAtVersion(name: string, version: string): string {
  return `${name}@${version}`;
}
